import { render, staticRenderFns } from "./campusbasicconfig.vue?vue&type=template&id=be7f2b08"
import script from "./campusbasicconfig.vue?vue&type=script&lang=js"
export * from "./campusbasicconfig.vue?vue&type=script&lang=js"
import style0 from "./campusbasicconfig.vue?vue&type=style&index=0&id=be7f2b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports